import React from "react";
import classes from "./ItemMenu.module.css";

const ItemMenu = (props) => {
  return (
    <article
      className={classes.profile}
      onClick={props.onClick}
      style={props.onClick ? { cursor: "pointer" } : {}}
      title={props.onClick ? `Ver movimientos con incidencia: ${props.text}` : ""}
    >
      <span style={{ color: `${props.color}` }}>●</span>
      <span className={classes.name}>{props.text}:</span>
      <span className={classes.value}>{props.count}</span>
    </article>
  );
};

export default ItemMenu;
